"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _emotion = require("emotion");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gauge = _interopRequireDefault(require("@amzn/meridian-tokens/component/gauge"));

var _theme = require("../theme");

var _token = require("./../_utils/token");

var _angle = require("./../_utils/angle");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var baseRadius = 8;
var shaftRadius = 2.5;
var pointRadius = 2;
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var x = _ref.x,
      y = _ref.y,
      color = _ref.color;
  return (0, _emotion.css)({
    fill: color || t("needleColor"),
    transition: "".concat(t("value", "motionDuration"), " ").concat(t("value", "motionFunction")),
    transformOrigin: "".concat(x, "px ").concat(y, "px"),
    stroke: t("needleBorderColor")
  });
}, ["x", "y", "color"]);
/**
 * Draws a needle constrained between a start and end angle at a percentage angle.
 *
 * NOTICE: This returns a vanilla svg <path/> so it must be used within an <svg/>.
 * Use the x/y props to position the center of the handle of the needle.
 */

var Needle = function Needle(props) {
  var percentage = props.percentage,
      startAngle = props.startAngle,
      endAngle = props.endAngle;
  var t = (0, _theme.useTheme)(_gauge["default"], "gauge");
  var sweepAngle = (0, _react.useMemo)(function () {
    return (0, _angle.getSweepAngle)(startAngle, endAngle);
  }, [startAngle, endAngle]);
  var path = (0, _react.useMemo)(function () {
    return ["M ".concat(props.x - baseRadius, " ").concat(props.y), "a 1 1 0 0 0 ".concat(baseRadius * 2, " 0"), "l -".concat(baseRadius - pointRadius, " -").concat(props.length), "a 1 1 0 0 0 -".concat(pointRadius * 2, " 0"), "l -".concat(baseRadius - pointRadius, " ").concat(props.length), "Z", "M ".concat(props.x - shaftRadius, " ").concat(props.y), "a 1 1 0 0 0 ".concat(shaftRadius * 2, " 0"), "a 1 1 0 0 0 -".concat(shaftRadius * 2, " 0"), "Z"].join(" ");
  }, [props.x, props.y, props.length]);
  return /*#__PURE__*/_react["default"].createElement("path", {
    d: path,
    fillRule: "evenodd",
    className: styles(t, props),
    style: {
      transform: "rotate(".concat(-90 + startAngle + sweepAngle * percentage, "deg)")
    }
  });
};

Needle.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Override the color of the needle.
   */
  color: _propTypes["default"].string,

  /**
   * The final angle the needle will rest at 100%.
   */
  endAngle: _propTypes["default"].number,

  /**
   * The length of the needle.
   */
  length: _propTypes["default"].number,

  /**
   * Where the needle should rest between the start and end angles.
   * Use float between 0 ~ 1 e.g. 0.4 for 40%.
   */
  percentage: _propTypes["default"].number,

  /**
   * The beginning angle the needle will rest at 0%.
   */
  startAngle: _propTypes["default"].number,

  /**
   * Where on the x axis to place the center of the needle's base.
   */
  x: _propTypes["default"].number,

  /**
   * Where on the y axis to place the center of the needle's base.
   */
  y: _propTypes["default"].number
} : {};
Needle.defaultProps = {
  length: 50,
  startAngle: 0,
  endAngle: 180,
  percentage: 0,
  x: 0,
  y: 0
};
var _default = Needle;
exports["default"] = _default;